'use client';

import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

export default function ButtonLink({ link, callToAction, theme = defaultTheme, external = false }) {
  return (
    <StyledButton theme={theme}>
      <Link
        to={link}
        target={external ? '_blank' : '_self'}
        rel={external ? 'noopener noreferrer' : undefined}
        className="animated-arrow"
      >
        <span className="the-arrow -left">
          <span className="shaft" />
        </span>
        <span className="main">
          <span className="text">{callToAction}</span>
          <span className="the-arrow -right">
            <span className="shaft" />
          </span>
        </span>
      </Link>
    </StyledButton>
  );
}

const defaultTheme = {
  main: '#100000',
  hover: '#978E7D',
  shaft: {
    width: '50px',
    thickness: '1px',
  },
  arrowHead: {
    width: '8px',
    thickness: '1px',
  },
  newShaftWidth: '50px',
  textArrowSpace: '16px',
  fontSize: '1.75em',
};

const StyledButton = styled.div`
  display: inline-block;

  .the-arrow {
    width: ${({ theme }) => theme.shaft.width};
    transition: all 0.2s;

    &.-left {
      position: absolute;
      top: 60%;
      left: 0;

      > .shaft {
        width: 0;
        background-color: ${({ theme }) => theme.main};

        &:before,
        &:after {
          width: 0;
          background-color: ${({ theme }) => theme.main};
        }

        &:before {
          transform: rotate(0);
        }

        &:after {
          transform: rotate(0);
        }
      }
    }

    &.-right {
      top: 3px;

      > .shaft {
        width: ${({ theme }) => theme.shaft.width};
        transition-delay: 0.2s;

        &:before,
        &:after {
          width: ${({ theme }) => theme.arrowHead.width};
          transition-delay: 0.3s;
          transition: all 0.5s;
        }

        &:before {
          transform: rotate(40deg);
        }

        &:after {
          transform: rotate(-40deg);
        }
      }
    }

    > .shaft {
      background-color: ${({ theme }) => theme.main};
      display: block;
      height: ${({ theme }) => theme.shaft.thickness};
      position: relative;
      transition: all 0.2s;
      will-change: transform;

      &:before,
      &:after {
        background-color: ${({ theme }) => theme.main};
        content: '';
        display: block;
        height: ${({ theme }) => theme.arrowHead.thickness};
        position: absolute;
        top: 0;
        right: 0;
        transition: all 0.2s;
      }

      &:before {
        transform-origin: top right;
      }

      &:after {
        transform-origin: bottom right;
      }
    }
  }

  .animated-arrow {
    display: inline-block;
    color: ${({ theme }) => theme.main};
    font-size: ${({ theme }) => theme.fontSize};
    font-style: italic;
    text-decoration: none;
    position: relative;
    transition: all 0.2s;

    &:hover {
      color: ${({ theme }) => theme.hover};

      > .the-arrow.-left > .shaft {
        width: ${({ theme }) => theme.newShaftWidth};
        transition-delay: 0.1s;
        background-color: ${({ theme }) => theme.hover};

        &:before,
        &:after {
          width: ${({ theme }) => theme.arrowHead.width};
          background-color: ${({ theme }) => theme.hover};
          transition-delay: 0.1s;
        }

        &:before {
          transform: rotate(40deg);
        }

        &:after {
          transform: rotate(-40deg);
        }
      }

      > .main {
        transform: translateX(
          calc(${({ theme }) => theme.newShaftWidth} + ${({ theme }) => theme.textArrowSpace})
        );

        > .the-arrow.-right > .shaft {
          width: 0;
          transform: translateX(200%);
          transition-delay: 0;

          &:before,
          &:after {
            width: 0;
            transition-delay: 0;
            transition: all 0.1s;
          }

          &:before {
            transform: rotate(0);
          }

          &:after {
            transform: rotate(0);
          }
        }
      }
    }

    > .main {
      display: flex;
      align-items: center;
      transition: all 0.2s;

      > .text {
        margin: 0 ${({ theme }) => theme.textArrowSpace} 0 0;
        line-height: 1;
      }

      > .the-arrow {
        position: relative;
      }
    }
  }
`;
